import { throwApiError } from "../../../api/api";
import { employeeApi } from "../../../api/employeeApi";

/**
 * Chamadas de autenticação do portal. Todas pelo `employeeApi` — nunca pelo
 * `api` do staff.
 *
 * `throwApiError` é reaproveitado de `api.ts`: é só um normalizador de erro do
 * axios, sem token nem baseURL dentro.
 */

export type EmployeeLoginResponse = {
  tokenType: "Bearer";
  accessToken: string;
  expiresIn: string;
  isFirstLogin: boolean;
  employee: { fullName: string };
};

export const loginEmployeeApi = async (
  cpf: string,
  password: string
): Promise<EmployeeLoginResponse> => {
  try {
    const { data } = await employeeApi.post<EmployeeLoginResponse>("/dp/auth/login", {
      cpf,
      password,
    });
    return data;
  } catch (error) {
    // A mensagem vem pronta do backend e é sempre a mesma ("Credenciais
    // inválidas."), qualquer que seja a causa. Não detalhar aqui é proposital.
    throwApiError(error, "Não foi possível entrar. Tente novamente.");
    throw error;
  }
};

export const changeFirstLoginPasswordApi = async (
  token: string,
  password: string,
  passwordConfirmation: string
): Promise<void> => {
  try {
    await employeeApi.post(
      "/dp/auth/first-login/change-password",
      { password, passwordConfirmation },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    throwApiError(error, "Não foi possível definir a senha.");
    throw error;
  }
};

export const changeEmployeePasswordApi = async (
  currentPassword: string,
  password: string,
  passwordConfirmation: string
): Promise<void> => {
  try {
    await employeeApi.post("/dp/auth/change-password", {
      currentPassword,
      password,
      passwordConfirmation,
    });
  } catch (error) {
    throwApiError(error, "Não foi possível alterar a senha.");
    throw error;
  }
};
